import React from "react";
import { Box, Container } from "@mui/material";
import StepsHeader from "../StepsHeader/StepsHeader";
import StepsFooter from "../StepsFooter/StepsFooter";

const StepLayout = ({ step, children }) => {
  return (
    <Box sx={{
      pt: 2, pb: 3, minHeight: "100vh",
      background: "linear-gradient(135deg, #ffffff 0%, rgba(19, 168, 158, 0.14) 100%)",
    }}>
      <Container maxWidth="lg">

        {/* Header */}
        <StepsHeader step={step} />

        {/* Step Content */}
        <Box sx={{ mt: 4 }}>
          {children}
        </Box>

        <StepsFooter step={step} />

      </Container>
    </Box>
  );
};

export default StepLayout;